@file:OptIn(ExperimentalWasmJsInterop::class, DelicateCoroutinesApi::class)

package app.smartcoding.realrate

import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import app.smartcoding.realrate.domain.tools.createKtorClient
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.launch

@JsFun("() => hidePreloader()")
external fun hidePreloader()

val firebaseOptions = FirebaseOptions(
    applicationId = "1:668012495066:web:5f1f3e346406217cc4e5e3", // от JS: appId
    apiKey = "AIzaSyCoKozd1fjMXK_X7OcNOECr4dmGRGOAS50",         // от JS: apiKey
    gaTrackingId = "G-PZKNZ27BF7",                               // от JS: measurementId
    storageBucket = "realrate-2026.firebasestorage.app",        // от JS: storageBucket
    projectId = "realrate-2026",                                // от JS: projectId
    gcmSenderId = "668012495066",                               // от JS: messagingSenderId
    authDomain = "realrate-2026.firebaseapp.com"               // от JS: authDomain (Важно за Google Sign-In!)
)

private val isDebugMode: Boolean by lazy {
    val isLocalhost = window.location.hostname == "localhost" || window.location.hostname == "127.0.0.1"
    val isDevEnv = js("process.env.NODE_ENV === 'development'") as? Boolean ?: false
    isLocalhost || isDevEnv
}

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    if (isDebugMode) {
        js("self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;")
    }
    Firebase.initialize(options = firebaseOptions)

    val appCheckInstance = try {
        val options = js("{}").unsafeCast<AppCheckOptions>()
        options.provider = ReCaptchaV3Provider(RE_CAPTCHA_SITE_KEY)
        options.isTokenAutoRefreshEnabled = true

        initializeAppCheck(getApp(), options)
    } catch (e: Exception) {
        println("App Check: $e")
        null
    }

    val tokenProvider = WebAppCheckTokenProvider(appCheckInstance)

    val auth = Firebase.auth

    val httpClient = createKtorClient(tokenProvider)

    GlobalScope.launch {
        if (isDebugMode) {
            println("isDebugMode = $isDebugMode")
            println("httpClient = $httpClient")
            println("appCheckInstance = $appCheckInstance")
            println("tokenProvider = ${tokenProvider.getToken()}")
            println("Firebase.auth user = ${auth.authStateChanged.first()?.displayName}")
        }
    }

    val rootElement = document.getElementById("shared") ?: document.body!!
    ComposeViewport(rootElement) {
        LaunchedEffect(Unit) {
            try {
                hidePreloader()
            } catch (e: Exception) {
                println("JS function not found: $e")
            }
        }
        App(isDebugMode)
    }
}